// extracted by mini-css-extract-plugin
module.exports = {"productLogo":"header-logo_productLogo__4Xkdh","logo":"header-logo_logo__rHbiM"};